export default __webpack_public_path__ + "static/media/Wolf's Jerkin of a Hundred Eyes.f1f4c3cd.jpg";